import React from 'react'
import { Route } from 'react-router-dom'
import { lazyRoute } from './lazy-route'

const WarehousePayments = React.lazy(() => import('@/pages/warehouse/PaymentOverview'))
const WarehouseBills = React.lazy(() => import('@/pages/warehouse/WacklerBills'))
const WarehouseOperationsLedger = React.lazy(() => import('@/pages/warehouse/OperationsLedger'))
const WarehouseCommunicationsTimeline = React.lazy(() => import('@/pages/warehouse/CommunicationsTimeline'))
const WarehouseKdpRegistry = React.lazy(() => import('@/pages/warehouse/KdpRegistry'))
const WarehouseRatesConfig = React.lazy(() => import('@/pages/warehouse/RatesConfig'))
const WacklerInvoiceResponse = React.lazy(() => import('@/pages/wackler/InvoiceResponse'))

// Legacy reconciliation paths (`/verify`, `/resolve`, `/operations`, bare
// `:month`) all render the unified OperationsLedger workspace — the W4-post
// absorption replaced the four separate pages. Four Route entries share one
// lazy chunk so deep-links from mail footers, bookmarks, and external docs
// still resolve without breaking. `reconciliation/close` likewise routes to
// the AP-aging ledger (per-bill closure is inline on the ledger now).
export function renderWarehouseRoutes(): React.ReactElement {
  return (
    <>
      <Route path="warehouse/bills" element={lazyRoute(WarehouseBills, 'Loading bills...')} />
      {/* Per-invoice reconciliation: same OperationsLedger UI, scoped to a
          single Wackler invoice via the invoice_number column on
          v_wackler_month_detail (migration 036c). PaymentOverview row click
          navigates here. */}
      <Route path="warehouse/wackler-invoice/:invoiceNumber" element={lazyRoute(WarehouseOperationsLedger, 'Loading invoice...')} />
      <Route path="warehouse/payments" element={lazyRoute(WarehousePayments, 'Loading billing...')} />
      <Route path="warehouse/config/kdp" element={lazyRoute(WarehouseKdpRegistry, 'Loading KDP...')} />
      <Route path="warehouse/config/rates" element={lazyRoute(WarehouseRatesConfig, 'Loading rates...')} />
      <Route path="warehouse/reconciliation/close" element={lazyRoute(WarehousePayments, 'Loading billing...')} />
      <Route path="warehouse/reconciliation/:month/resolve" element={lazyRoute(WarehouseOperationsLedger, 'Loading operations...')} />
      <Route path="warehouse/reconciliation/:month/verify" element={lazyRoute(WarehouseOperationsLedger, 'Loading operations...')} />
      <Route path="warehouse/reconciliation/:month/operations" element={lazyRoute(WarehouseOperationsLedger, 'Loading operations...')} />
      <Route path="warehouse/reconciliation/:month/timeline" element={lazyRoute(WarehouseCommunicationsTimeline, 'Loading timeline...')} />
      <Route path="warehouse/reconciliation/:month" element={lazyRoute(WarehouseOperationsLedger, 'Loading operations...')} />
      <Route path="wackler/invoice/:billId" element={lazyRoute(WacklerInvoiceResponse, 'Loading invoice...')} />
    </>
  )
}
